/** Historical users are included before adding each day's registrations. */
export function cumulativeUserSeries(dates, total, registration_daily) {
  const increments = new Map(registration_daily.map(row => [row.date, row.count]))
  let running = total - registration_daily.reduce((sum, row) => sum + row.count, 0)
  return dates.map(date => {
    running += increments.get(date) ?? 0
    return running
  })
}
